import { httpUrl } from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-lock`
let baseUrl2 = `${httpUrl.host}/gy-apartment`

let api = {
  // 楼栋列表
  getBuildingList: `${baseUrl2}/building/getBuildingList`,

  // 房间列表
  getRoomInfoList: `${baseUrl2}/roomInfo/getRoomInfoList`,

  // 集中器管理——分页
  getConcentratorPage: `${baseUrl}/concentrator/getPage`,

  // 集中器管理——添加
  addConcentrator: `${baseUrl}/concentrator/add`,

  // 集中器管理——修改
  updateConcentrator: `${baseUrl}/concentrator/update`,

  // 集中器管理——详情
  getConcentratorByCode: `${baseUrl}/concentrator/getByCode`,

  // 集中器管理——删除
  deleteConcentratorByCodes: `${baseUrl}/concentrator/deleteByCodes`,

  // 门锁管理——分页
  getLockPage: `${baseUrl}/lock/getPage`,

  // 门锁管理——添加
  addLock: `${baseUrl}/lock/add`,

  // 门锁管理——修改
  updateLock: `${baseUrl}/lock/update`,

  // 门锁管理——详情
  getLockByCode: `${baseUrl}/lock/getByCode`,

  // 门锁管理——人员列表
  getPersonList: `${baseUrl2}/person/getPage`,

  // 门锁管理——删除
  deleteLockByCodes: `${baseUrl}/lock/deleteByCodes`,

  // 权限管理——分页
  getAuthorizedPage: `${baseUrl}/authorized/getPage`,

  // 权限管理——添加
  addAuthorized: `${baseUrl}/authorized/add`,

  // 权限管理——详情
  getLockByRoomCode: `${baseUrl}/lock/getByRoomCode`,

  // 权限管理——删除
  deleteAuthorizedByCodes: `${baseUrl}/authorized/deleteByCodes`,

  // 权限管理——修改
  updateAuthorizedCardNumber: `${baseUrl}/authorized/updateCardNumber`,

  // 识别记录——分页
  getIdentifyRecordPage: `${baseUrl}/ldentifyRecord/getPage`,

  // 授权记录——分页
  getAuthorizationRecordPage: `${baseUrl}/authorizationRecord/getPage`,
}

export { api }



// WEBPACK FOOTER //
// ./src/view/api/Lock.js